// ColorContext.js
import React, { createContext, useEffect } from 'react';
import { initCurrency } from 'utils/currency';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// Create Context
export const ColorContext = createContext();

// Create a provider component
export const ColorProvider = ({ children }) => {
    // website-info is already fetched into Redux by CustomLayout (and cached to
    // localStorage on first load) — read it here instead of fetching it again.
    const websiteInfo = useSelector((state) => state.webDetails?.websiteInfo) || {};
    const loader = _.isEmpty(websiteInfo);
    // Once the store's own currency is known, set up display-only conversion
    // into the visitor's currency.
    useEffect(() => {
        if (websiteInfo.currency_symbol || websiteInfo.currency_code) {
            initCurrency(websiteInfo.currency_symbol, websiteInfo.currency_code);
        }
    }, [websiteInfo.currency_symbol, websiteInfo.currency_code]);
    const colors = {
        header_bg: websiteInfo.header_bg,
        header_text: websiteInfo.header_text,
        footer_bg: websiteInfo.footer_bg,
        footer_text: websiteInfo.footer_text,
    };

    return (
        <ColorContext.Provider value={{colors,loader}}>
            {children}
        </ColorContext.Provider>
    );
};
